<svc-quill-text-editor
  class="w-full"
  [maxHeight]="readOnly ? null : '150px'"
  [minHeight]="readOnly ? null : (parent.smallSize ? '45px' : '52px')"
  [applyBorder]="false"
  [class.small-size]="parent.smallSize"
  svcQuillEditorMention
  [class.cursor-force]="cursorForce"
  [class.cursor-force]="cursorForce"
  [placeholder]="!readOnly ? placeholder : null"
  [readOnly]="readOnly ?? false"
  [applyMention]="true"
  [placeholder]="!(readOnly ?? false) ? placeholder : null"
  [formControl]="control"
  (onRender)="onEditorRender()"
/>
@if (!hideSendButton) {
  <button
    svc-filled-btn-icon
    icon="fontawesome_solid:paper-plane"
    [color]="loading || buttonDisabled ? 'text' : 'primary'"
    iconSize="5"
    class="absolute right-2.5 rounded-full"
    [class]="parent.smallSize ? 'small-button top-2.5' : 'top-2 w-10 h-10 max-w-none max-h-none'"
    [disabled]="loading || buttonDisabled"
    [processing]="loading"
    (click)="!loading && !buttonDisabled && onButtonClicked.emit()"
  ></button>
}
